module.exports = __webpack_public_path__ + "static/media/06_cracked_balls.0532821e.jpg";